import { JourneyCompare, JourneyExploreResult, JourneyMeta } from '../../../models/journey-explorer/journey-explorer';
import { displayValue } from './journey-explorer-utils';

const CHURN_STATUS_COLUMN = 'CHURN_STATUS';

export interface CompareSide {
	label: string;
	result: JourneyExploreResult | null;
}

export interface CompareData {
	spec: JourneyCompare;
	a: CompareSide;
	b: CompareSide;
}

export type ComparePair = [number | null, number | null];

export interface CompareDimension {
	column: string;
	label: string;
	values: string[];
}

export const compareDimensions = (meta: JourneyMeta): CompareDimension[] =>
	meta.customer_dimensions
		.filter((dimension) => dimension.column !== CHURN_STATUS_COLUMN)
		.map((dimension) => ({
			column: dimension.column,
			label: dimension.label,
			values: Array.from(new Set(dimension.values.map(displayValue))),
		}))
		.filter((dimension) => dimension.values.length >= 2);

const pick = <T>(
	compare: CompareData,
	find: (result: JourneyExploreResult) => T | undefined,
	share: (item: T) => number
) =>
	[compare.a.result, compare.b.result].map((result) => {
		const item = result ? find(result) : undefined;
		return item === undefined ? null : share(item);
	}) as ComparePair;

export const interactionPair = (compare: CompareData, name: string): ComparePair =>
	pick(
		compare,
		(result) => result.interactions.find((item) => item.name === name),
		(item) => item.reached_pct
	);

export const transitionPair = (compare: CompareData, from: string, to: string): ComparePair =>
	pick(
		compare,
		(result) => result.transitions.find((item) => item.from === from && item.to === to),
		(item) => item.reached_pct
	);

export const pathPair = (compare: CompareData, pathKey: string): ComparePair =>
	pick(
		compare,
		(result) => result.paths.find((item) => item.path_key === pathKey),
		(item) => item.reached_pct
	);

export const formatPct = (value: number | null | undefined): string =>
	value === null || value === undefined ? '–' : `${value.toFixed(0)}%`;
